if (typeof productsCarrusel !== 'function') {
    class productsCarrusel extends HTMLElement {
        constructor() {
            super();
            this.galleries = this.querySelectorAll('[data-carrusel-products]');
            this.waitForSlick();    
        }

        waitForSlick() {
            const checkSlicknA = setInterval(() => {
                if (window.jQuery && typeof jQuery.fn.slick !== 'undefined') {
                    clearInterval(checkSlicknA);
                    this.initSlick();
                }
            }, 100);
        }

        initSlick() {
            if (!this.galleries) return;

            this.galleries.forEach((gallery) => {
                if (window.jQuery) {
                    jQuery(gallery).slick({
                        dots: false,
                        arrows: true,
                        infinite: true,
                        slidesToShow:4,
                        slidesToScroll: 1,
                        speed: 300,
                        autoplay: true,
                        autoplaySpeed: 8000,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2.1,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    arrows: false,
                                    dots: false,
                                    infinite: false
                                }
                            }
                        ]
                    });
                }

            })
            
            
        }
    }
    if (typeof customElements.get('carrusel-products') === 'undefined') {
        customElements.define('carrusel-products', productsCarrusel);
    }
}